// Spedcare Services - Mock Data
// Extracted from Stitch HTML designs

export const siteConfig = {
  name: "Spedcare Services",
  tagline: "Registered NDIS Provider",
  description: "Professional NDIS providers dedicated to delivering excellence in care and community support.",
  contact: {
    phone: "1800-SPEDCARE",
    email: "info@spedcare.com.au",
    address: "88 Wellness Boulevard, Suite 200, Melbourne VIC 3000",
    melbourne: {
      address: "88 Wellness Boulevard, Melbourne VIC 3000",
      phone: "(03) 9123 4567"
    },
    sydney: {
      address: "42 Harmony Street, Sydney NSW 2000",
      phone: "(02) 9234 5678"
    },
    hours: "Mon-Fri, 8am - 6pm"
  },
  registration: {
    abn: "98 765 432 109",
    acn: "987 654 321",
    providerNumber: "4050087654"
  },
  social: {
    facebook: "#",
    linkedin: "#",
    website: "#"
  }
} as const;

export const navigation = {
  main: [
    { label: "Home", href: "/", active: false },
    { label: "About Us", href: "/about", active: false },
    { label: "Services", href: "/services", active: false },
    { label: "NDIS Info", href: "#", active: false },
    { label: "Contact", href: "/contact", active: false }
  ],
  footer: {
    quickLinks: [
      { label: "About Our Team", href: "#" },
      { label: "Support Coordination", href: "#" },
      { label: "Community Participation", href: "#" },
      { label: "NDIS Pricing Guide", href: "#" }
    ],
    legal: [
      { label: "Privacy Policy", href: "#" },
      { label: "Terms of Service", href: "#" },
      { label: "Participant Handbook", href: "#" },
      { label: "Compliance Statement", href: "#" }
    ],
    services: [
      { label: "Community Nursing", href: "#" },
      { label: "SDA/SIL Housing", href: "#" },
      { label: "Life Skills Training", href: "#" },
      { label: "Youth Programs", href: "#" },
      { label: "In-Home Care", href: "#" }
    ]
  }
} as const;

export const homePage = {
  hero: {
    badge: "Registered NDIS Provider",
    headline: "Welcome To Spedcare Services",
    subheadline: "Empowering NDIS participants with professional, systematic, and passionate care tailored to your unique journey. We provide support that respects your independence and celebrates your progress.",
    ctaPrimary: "Our Services",
    ctaSecondary: "Learn More",
    image: {
      src: "https://lh3.googleusercontent.com/aida-public/AB6AXuBXmpJYY8DESsUkeVXEmIOvj-nMdBJKPAdvtEZDO_AMJ4WHm-nJg09JAIoiscxWzUrF77CyuLSpLThgXHx6RiZ3R1A1R7MYH70WFGSlgGBSuL1Uu12JumfCmEx6SCnnQtutI3xRZzT6pR-jY1SIDcli6kuUWa7PU2BQVw42SNNTvC0Y5iK9ouIIWxEFF9NZEyA8fGrShYfuCHEKVhi22e62WUucgK-EGLLT5O7SCxhiEprtiS-gHDLngCTtfLVa4pHWO3Zk8yskNvg",
      alt: "Healthcare provider smiling at elderly client"
    }
  },
  values: {
    title: "Our SPEED Values",
    subtitle: "Core Principles",
    items: [
      {
        letter: "S",
        title: "Systematic",
        description: "Structured and reliable care plans designed for consistency and individual success.",
        icon: "settings"
      },
      {
        letter: "P",
        title: "Passionate",
        description: "Heartfelt dedication from a team that truly cares about your well-being.",
        icon: "favorite"
      },
      {
        letter: "E",
        title: "Empower",
        description: "Building your confidence and independence to achieve your goals.",
        icon: "bolt"
      },
      {
        letter: "E",
        title: "Efficient",
        description: "Timely and responsive support delivery that respects your schedule.",
        icon: "timer"
      },
      {
        letter: "D",
        title: "Deliver Standards",
        description: "Committed to clinical excellence and the highest quality standards.",
        icon: "verified"
      }
    ]
  },
  services: {
    title: "Professional NDIS Services",
    subtitle: "Our Expertise",
    cta: "View All Services",
    items: [
      {
        title: "Support Coordination",
        description: "Navigating your NDIS plan and connecting you with the best available providers.",
        icon: "account_tree"
      },
      {
        title: "Daily Living Tasks",
        description: "Personal care and household tasks to help you maintain independence at home.",
        icon: "home"
      },
      {
        title: "Community Participation",
        description: "Engaging in social, recreational, and educational activities in your community.",
        icon: "groups"
      },
      {
        title: "Therapeutic Support",
        description: "Specialized therapies designed to improve mobility, communication, and well-being.",
        icon: "health_and_safety"
      }
    ]
  },
  mission: {
    title: "Our Mission",
    content: "To provide exceptional disability support services that enhance quality of life and foster a sense of belonging. We aim to break barriers and create opportunities for every participant to thrive in their community.",
    points: [
      "Promoting inclusive environments for all individuals.",
      "Ensuring clinical safety and person-centered planning."
    ]
  },
  vision: {
    title: "Our Vision",
    content: "To be the leading NDIS provider recognized for excellence, innovation, and unwavering commitment to the rights and dignity of people with disabilities across Australia.",
    quote: "Our goal is simple: to make every day better for our participants through meaningful connections and reliable care."
  },
  cta: {
    headline: "Share Your Cares With Us",
    subheadline: "We're here to listen and provide the support you need. Contact us today for a free consultation about your NDIS journey.",
    primary: "Get Started Now",
    secondary: "Call 1800-SPED"
  }
} as const;

export const aboutPage = {
  hero: {
    title: "Empowering Lives Through Dedicated Care",
    subtitle: "Providing professional NDIS support with excellence and empathy for individuals and families.",
    breadcrumb: { home: "Home", current: "About Us" },
    image: {
      src: "https://lh3.googleusercontent.com/aida-public/AB6AXuADL5dTZl8Ly3Se4AQGEzfr7xp0T3v8UWybr50vdRmMaWdep5cv4ZSdMtt4wEms9xnwRNL1MY7AiyYbyKPMEujbTNXh4VkRND-6JN_0WqMSQeMkPncgJLg6d0X74LiNIAMfWzhZliqNy546-dHaS10uBnPwMO8bwcuO8BEBL68KblJaZEsNGhuB6SFjQ3cHlI-wsDN_lPcNPLX-LCtyY_8CfE9E1DFk9-9HiaiXrwAiQEq29UmMNmmeGtooK4a-Vj3LIhr1GuUuOmo",
      alt: "Caring nurse smiling while assisting an elderly person"
    }
  },
  story: {
    tag: "Our Story",
    title: "Collaboration and Community: How We Started",
    paragraphs: [
      "Spedcare Services was founded on the principle of providing high-quality, accessible care to NDIS participants. Our journey began with a simple observation: the community needed more than just clinical assistance; it needed true connection and empowerment.",
      "Over the years, we have grown from a small passionate team to a trusted NDIS provider, but our core mission remains unchanged. We believe that every individual deserves to live a life of dignity, choice, and active community participation."
    ],
    quote: "Our success is measured by the smiles and independence of those we support every single day.",
    image: {
      src: "https://lh3.googleusercontent.com/aida-public/AB6AXuCibwqrn2UgAw5KWblq1wY4E0SBbHjllVnItzGq1C3Qw_CzGQNiPW6O0B3zBobqPscuXFJz06UpOqi-7x2xbqcpFdHO9Gq689-AyZ13XWqw2krRgH0DGOtCDBxxHY9MRJiZ_BWqpsgtUC4PfOZf929vecHIzxIiTlUndAUq8PvDxJxj-4IUmvDYQnau15KDf4PrBrYgqxzODcHclNmZV9Ke6byTEKAgqe1dWhfknjNnXDu5dR-pBgoo8n4IqJ5umnIW__AjRpeShgU",
      alt: "Group of diverse healthcare professionals discussing care plans"
    }
  },
  missionVision: {
    mission: {
      title: "Our Mission",
      content: "To provide personalized, high-quality NDIS support services that empower individuals with disabilities to achieve their goals, enhance their independence, and live fulfilling lives within their communities."
    },
    vision: {
      title: "Our Vision",
      content: "To be the leading and most trusted choice for NDIS participants across the region, recognized for our unwavering commitment to excellence, innovation in care, and heart-centered approach to human services."
    }
  },
  values: {
    title: "Our SPEED Values",
    subtitle: "These core principles guide every interaction and decision we make as a provider.",
    items: [
      { letter: "S", title: "Service", description: "Committed to going above and beyond in every task.", icon: "volunteer_activism" },
      { letter: "P", title: "Passion", description: "Fuelled by a genuine love for helping others thrive.", icon: "favorite" },
      { letter: "E", title: "Excellence", description: "Maintaining the highest standards in professional care.", icon: "verified" },
      { letter: "E", title: "Empathy", description: "Understanding the unique journey of every participant.", icon: "sentiment_satisfied" },
      { letter: "D", title: "Dependability", description: "Reliable support you can trust at any time.", icon: "handshake" }
    ]
  },
  team: {
    title: "Meet the Heart of Spedcare",
    subtitle: "Dedicated professionals committed to your well-being and growth.",
    members: [
      {
        name: "Sarah Henderson",
        role: "Founder & Managing Director",
        bio: "With over 15 years in disability services, Sarah founded Spedcare to bridge the gap in personalized support.",
        image: {
          src: "https://lh3.googleusercontent.com/aida-public/AB6AXuAf-bXIwjqJPSENq4ke4MBL-uC1iN3w63q_x_Nv9oZUPGyrtwPx1rKSXep7tVZgEhA706OakX5ngdfJrwmEx2hITKbw_NfilP3iKNNu8z44bUBMUcQx6A842Pq9DeBKY7qhOV_oDI3F_Dj5S5WeUCbUrDbjwMJ9n_dwxp2vZYIOFr7X6-I1rEWvCY4_JKwjaePc4jxD67uHH8cYXZ3M4ajdDqrG9Hr-IhFXgWbvfuDlq4uru_A1UiSXLnyCaZiQeYrsd2SL6wB6Q6A",
          alt: "Professional portrait of the founder of Spedcare"
        }
      },
      {
        name: "David Chen",
        role: "Lead Care Coordinator",
        bio: "David ensures that every participant is matched with the right support workers to achieve their unique goals.",
        image: {
          src: "https://lh3.googleusercontent.com/aida-public/AB6AXuBC0wie0JOpKMV6879SKqRE41ESjhaU7HBzbcnvg69tYynEX3-jjZVoY3ImKDw36LG4rJ5vedaMPJUJdUHmMbML9ZgT0jCchVvZ7tS3Kvo8CnnOEp1rH6vzRNsbh7x4BrwCh7SHrHRTonnJdunh83VZyRKkdfkJEXI86MwqXrA2HvjMAWI9EOzw2yUOIEOlQGIjUDuZyd4muOXR0rVHFjn3u5zLvM8A8l2l3Sgk9LYAucykq3LwvOUVwK8uwQh0COfzKCNslGhoK7s",
          alt: "Professional portrait of a care coordinator"
        }
      },
      {
        name: "Maria Rodriguez",
        role: "Field Operations Manager",
        bio: "Maria leads our frontline support staff, ensuring consistent delivery of high-quality, empathetic care.",
        image: {
          src: "https://lh3.googleusercontent.com/aida-public/AB6AXuCAeMgqJkPF87U-pi-3TRIL2FgHwoY4TPpRo6mvEMYjB9b0in-b215qil8nHmAljwBqYcr_Bv5j_5K8MQfgwyRqHZF68IEnkmkw8teM56aGWQTHicD6xBbQTQ7mz_UkT-P9OJ8WMSKFUtwDE_A3J6yC6V-KwzUkeYzB6nBZgvQD_1WVsomDyAqSglyFlnWQs8U2Gbi0Z4yblX9jF43p3RIf4GrY6vWe4COfON14C3Et_4XJSFFEiRii4BqmjGkLlHEfOO8oycG6ay0",
          alt: "Friendly portrait of a lead support worker"
        }
      }
    ]
  },
  cta: {
    title: "Ready to begin your journey with us?",
    primary: "Enquire Today",
    secondary: "View Services"
  }
} as const;

export const servicesPage = {
  hero: {
    badge: "Empowering Your Independence",
    title: "Compassionate NDIS Support Tailored to You",
    description: "At Spedcare Services, we believe everyone deserves to live a full and independent life. Our team of professionals partners with you to provide the specialized care and skills development you need to thrive.",
    ctaPrimary: "View Our Programs",
    ctaSecondary: "Free Consultation",
    image: {
      src: "https://lh3.googleusercontent.com/aida-public/AB6AXuDdqzKJf-VcYmP8S1onq8BTKRJQpG19mu-DX7LG_AlXwkxc3hRZTxCS3PhYfSBc6q0d7JsTNGCkd2XJAPO8o3YJkogVf4ai3EGcGiHzuAodNy1iP56Jw0eQULHej65tV6p9ld--EE9iqcdWZaBy-pRYdzcRdxsM5mEyZzF4QCtkjid8GrwvbivRRdgqWq0AE2GhKZlBHBVwHPcUZzCOBcRXERPXFdA5Ig9utPIO2jKvwrmj0WDKHwnPAkJ_2DPUfxOolNXGMKNHjug",
      alt: "Support worker smiling with an elderly patient in home"
    }
  },
  servicesGrid: {
    title: "Comprehensive Support Programs",
    subtitle: "We offer a wide range of registered NDIS supports designed to assist participants in every stage of their life journey.",
    services: [
      {
        title: "Assist Life Stage Transition",
        description: "Supporting participants through major changes like moving house or starting a new job.",
        icon: "trending_up",
        features: ["Mentoring & Peer Support", "Individual Skill Development", "Assistance with Decision Making"],
        color: "primary"
      },
      {
        title: "Community Nursing Care",
        description: "In-home clinical care provided by registered nurses for complex health needs.",
        icon: "medical_information",
        features: ["Medication Management", "Wound & Diabetes Care", "Post-Hospital Recovery Support"],
        color: "accent"
      },
      {
        title: "Daily Living Life Skills",
        description: "Training focused on increasing independence in your home and community.",
        icon: "self_improvement",
        features: ["Household Task Training", "Financial & Budgeting Skills", "Public Transport Training"],
        color: "primary"
      },
      {
        title: "Personal Care Support",
        description: "Dignified assistance with personal daily routines to help you feel your best.",
        icon: "volunteer_activism",
        features: ["Showering & Dressing", "Grooming & Oral Hygiene", "Meal Preparation & Support"],
        color: "accent"
      },
      {
        title: "Group & Centre Activities",
        description: "Social community participation through engaging and inclusive group programs.",
        icon: "groups",
        features: ["Creative Arts & Workshops", "Community Outings", "Fitness & Wellness Groups"],
        color: "primary"
      },
      {
        title: "Travel & Transport",
        description: "Reliable transport assistance for your medical appointments and social life.",
        icon: "commute",
        features: ["Specialised Vehicle Support", "Door-to-Door Assistance", "Support for Grocery Shopping"],
        color: "accent"
      }
    ]
  },
  process: {
    title: "Our NDIS Partnership Process",
    description: "Starting your NDIS journey can be overwhelming. We've simplified our partnership process into four clear steps to ensure you feel supported and informed at every stage.",
    steps: [
      {
        number: 1,
        title: "Initial Consultation",
        description: "A free, no-obligation chat to understand your NDIS plan, your goals, and your unique support needs."
      },
      {
        number: 2,
        title: "Service Agreement & Goal Setting",
        description: "We outline exactly how we will support you, set measurable goals, and establish a transparent service plan."
      },
      {
        number: 3,
        title: "Support Coordination",
        description: "Our dedicated coordinators manage your care schedules and ensure all your supports are working together seamlessly."
      },
      {
        number: 4,
        title: "Ongoing Review",
        description: "We regularly review your progress and adjust supports as your goals evolve and your life changes."
      }
    ]
  },
  categories: {
    title: "NDIS Support Categories",
    subtitle: "Spedcare Services is registered to provide supports under several NDIS registration groups:",
    items: [
      {
        title: "Core Supports",
        description: "Helping you with everyday tasks and community participation."
      },
      {
        title: "Capacity Building",
        description: "Developing skills that help you move towards your long-term goals."
      },
      {
        title: "Capital Supports",
        description: "Assistive technology or home modifications to improve access."
      }
    ],
    footerNote: "Need help understanding your plan? Our NDIS experts are ready to guide you."
  },
  cta: {
    title: "Ready to get started?",
    description: "Take the first step towards a more independent and fulfilling life. Our team is here to help you navigate your NDIS plan.",
    primary: "Request a Callback",
    secondary: "Find a Local Office",
    phone: "1800 123 456",
    email: "hello@spedcare.com.au"
  }
} as const;

export const contactPage = {
  hero: {
    title: "Contact Spedcare Services",
    description: "We're here to support your NDIS journey with professional and warm healthcare services. Reach out to our team for personalized assistance."
  },
  form: {
    title: "Send us a message",
    fields: {
      name: { label: "Full Name", placeholder: "John Doe", required: true },
      email: { label: "Email Address", placeholder: "john@example.com", required: true },
      phone: { label: "Phone Number", placeholder: "0400 000 000", required: true },
      subject: { label: "Inquiry Subject", options: ["NDIS Support Coordination", "In-Home Support", "Community Nursing", "Daily Life Tasks", "General Inquiry"] },
      message: { label: "Your Message", placeholder: "How can we help you today?", required: true, rows: 5 }
    },
    privacyNote: "Your information is handled securely according to our Privacy Policy.",
    submitButton: "Submit Inquiry"
  },
  locations: [
    {
      city: "Melbourne",
      label: "Melbourne HQ",
      address: "88 Wellness Boulevard, Melbourne VIC 3000",
      phone: "(03) 9123 4567",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuDEy3h5yg54TXOsqFf8qJGFnkOJHTVINhj9VoQfplzodGthsnplRXcEwSDRUgiBTSU6eD2Pq2e55a3TE5wZ5YWGheBGfu5TShZQPV5i8Z2L3qVq-cY1o3kEZpGsH5ku13kVkCQOMH4X-jZB1tyEkwSrzMLlPSYYqblvfC50q5miGw9nghzN9tLySAAib0Jc3dPR788n2n5ibYxi4dIlByKlG18GquxzfrtpyF4nNDOmZWVM1oAB61cQRYzPBoTNik-AK37OvwzdTNM"
    },
    {
      city: "Sydney",
      label: "Sydney Office",
      address: "42 Harmony Street, Sydney NSW 2000",
      phone: "(02) 9234 5678",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuCxYMuugwFcOiL4h2hTQ3LWAOcxmmHak4IjU3UzJH0iIw2FkRHoe4J6MS9lnliGN0LpZzDBxhbZsxzouxO9xUs8RfT3ApJYUzRh7GAqSUSY9_wYix446LND9lNxNjR1ymZh-gANVaIWxd3b8JVAoEunz9A5IbLf5cx6hw8csGm8FSSJRThJeJgpqxdarMPSLmY44M7Aos6Flsl5xccH2gYi4ENVgnGbuldNhTtKUDOK4LYLts95FEPsHEtOJ1ehBHpRCc7fMwK4wV4"
    }
  ],
  faq: {
    title: "Common Questions",
    subtitle: "Find quick answers to typical NDIS service queries.",
    items: [
      {
        question: "How do I start my NDIS plan with Spedcare?",
        answer: "Starting is simple. Contact our team through the form above or call our Melbourne branch. We will assign a dedicated support coordinator to walk you through our intake process and align our services with your NDIS plan goals."
      },
      {
        question: "Do you offer in-home support in regional areas?",
        answer: "Yes, while our main branches are in Melbourne and Sydney, we have a network of qualified healthcare professionals providing in-home support across various regional centers in Victoria and New South Wales."
      },
      {
        question: "Is Spedcare a registered NDIS provider?",
        answer: "Absolutely. We are fully registered with the NDIS Quality and Safeguards Commission. Our registration number is 4050087654, ensuring we meet all national standards for safety and quality."
      }
    ]
  }
} as const;

export type SiteConfig = typeof siteConfig;
export type Navigation = typeof navigation;
export type HomePage = typeof homePage;
export type AboutPage = typeof aboutPage;
export type ServicesPage = typeof servicesPage;
export type ContactPage = typeof contactPage;
